import {
  selector_initial_setup,
  setup_determinePlaceholder,
  setup_determineValueCurrent,
  setup_list,
  setup_mainStructure,
  setup_reinitInitial,
  structure_generateWrapperHead
} from "./jsinc/_selector-setup";
import {assets, dzs_slide_down, dzs_slide_up} from './jsinc/_selector-functions';
import {setup_listeners} from "./jsinc/_selector-actions";
import {
  opener_clearBigOptions,
  opener_determineAreas,
  opener_setupBigOptions,
  opener_setupStructure
} from "./jsinc/_view-openerArea";

window.dzssel_startup_init = true;
window.dzssel_click_triggered = false;


/**
 * @property $selectInputForm - the select element ( if it exists )
 * @property $dzsSelectorMain - the native element
 */
class DzsSelector {
  constructor($element_, $, finalOptions) {

    this.$ = $;
    this.$element_ = $element_;
    this.initOptions = finalOptions;

    this.$wrapperMain = null;
    this.$dzsSelectorMain = null;
    this.$feederObject = null;
    this.$selectInputForm = null;
    this.$openerWrap = null;
    this.$openerMain = null;


    this.nativeInputType = 'select';
    this.feedElementClass = 'select';

    this.isAlreadySetup = false;
    this.valueCurrent = '';
    this.selectedIndex = null;

    this.classInit();

  }

  classInit() {

    var $ = this.$;

    var selfInstance = this;


    var o = selfInstance.initOptions;


    selfInstance.$dzsSelectorMain = $(this.$element_);
    selfInstance.feedElementClass = String(selfInstance.$dzsSelectorMain.attr('class'));


    init();

    function init() {
      selfInstance.feedElementClass = selfInstance.feedElementClass.replace('dzs-style-me', '');

      selector_initial_setup(selfInstance)

      selfInstance.close_opener = close_opener;
      selfInstance.open_opener = open_opener;
      // selfInstance.openSelect = openSelect;


      if (selfInstance.$dzsSelectorMain.hasClass('type-checkbox')) {
        selfInstance.nativeInputType = 'checkbox';
      }


      if (selfInstance.$dzsSelectorMain.get(0) && selfInstance.$dzsSelectorMain.get(0).nodeName === "INPUT") {
        return false;
      }

      //console.info(o);

      //console.info(_t);


      // -- if we have treated this , we have parent
      if (selfInstance.isAlreadySetup) {


        setup_reinitInitial(selfInstance);
        return false;
      }

      selfInstance.$dzsSelectorMain.addClass('treated');


      setup_mainStructure(selfInstance);

      setup_determinePlaceholder(selfInstance);

      setup_determineValueCurrent(selfInstance);

      selfInstance.$wrapperMain.prepend(structure_generateWrapperHead(selfInstance));


      // console.log('selfInstance.$dzsSelectorMain -' , selfInstance.$dzsSelectorMain);
      // -- if we have ul element
      if (selfInstance.$dzsSelectorMain.get(0) && selfInstance.$dzsSelectorMain.get(0).nodeName === 'UL') {
        setup_list(selfInstance);
      }


      if (selfInstance.$dzsSelectorMain.parent().find('select').length) {
        selfInstance.$selectInputForm = selfInstance.$dzsSelectorMain.parent().find('select').eq(0);
      }


      setup_listeners(selfInstance);


      //console.log(selfInstance.$wrapperMain);
      setTimeout(function () {

        selfInstance.$wrapperMain.addClass('init-readyall')
      }, 100);

      // console.log('o.opener - ', o.opener);


      if(o.opener.indexOf('opener-')===0){

        if (selfInstance.$feederObject) {

          opener_setupStructure(selfInstance);


          reinit();


          if (selfInstance.$openerMain) {

            selfInstance.$openerMain.find('.select-option').eq(selfInstance.selectedIndex).addClass('active-checked');
          }
        }
      }


      if (selfInstance.$selectInputForm) {

        selfInstance.$selectInputForm.get(0).api_reinit = reinit;
        selfInstance.$selectInputForm.get(0).api_destroy = destroy;
        selfInstance.$selectInputForm.get(0).api_recheck_value_from_input = recheck_value_from_input;
      }


    }

    function destroy() {


      console.info('destroying', selfInstance.$selectInputForm);

      if (selfInstance.$selectInputForm.prev().hasClass('dzs-select-wrapper-head')) {
        selfInstance.$selectInputForm.prev().remove();
      }

      if (selfInstance.$selectInputForm.next().hasClass('opener-listbuttons-wrap')) {
        selfInstance.$selectInputForm.next().remove();
      }

      if (selfInstance.$selectInputForm.parent().hasClass('dzs-select-wrapper')) {
        selfInstance.$selectInputForm.unwrap();
      }
    }

    function recheck_value_from_input() {

      // -- we can call this from api

      // console.log('recheck_value_from_input() ')

      var ind = 0;
      selfInstance.$selectInputForm.children().each(function () {
        var _t2 = $(this);

        // console.info('_t2 - ',_t2);
        // console.info('_t2.prop(checked) - ',_t2.prop('selected'));

        if (_t2.prop('selected')) {

          // console.info('final ind - ',ind);


          if (selfInstance.$openerWrap) {

            selfInstance.$openerWrap.children().removeClass('active-checked');
            selfInstance.$openerWrap.children().eq(ind).addClass('active-checked');
          }
          selfInstance.$dzsSelectorMain.parent().find('.dzs-select-wrapper-head .the-text').html(_t2.html());
          return false;
        }

        ind++;


      })


      // console.info(_opener_main);
      // console.info(_opener_wrap);

    }

    function close_opener(pargs) {


      var margs = {
        call_from: 'default'
      };


      if (pargs) {
        margs = jQuery.extend(margs, pargs);
      }


      // console.info('close_opener', margs);

      var delay = 300;

      selfInstance.$wrapperMain.removeClass('active-animation');
      if (o.opener === 'opener-list') {
        delay = 0;
      }
      setTimeout(function () {
        selfInstance.$wrapperMain.removeClass('active-checked');
      }, delay);


      if (String(selfInstance.feedElementClass).indexOf('opener-bigoptions') > -1) {


        dzs_slide_up(selfInstance.$openerWrap, {
          duration: delay
          , queue: false
          , complete: function () {

          }

        })

        ;
      }

      selfInstance.$wrapperMain.find('.search-field').val('').trigger('keyup');
    }

    function open_opener() {
      selfInstance.$wrapperMain.addClass('active-checked');
      setTimeout(function () {
        selfInstance.$wrapperMain.addClass('active-animation');
      }, 50);


      // console.info(selfInstance.feedElementClass);
      if (String(selfInstance.feedElementClass).indexOf('opener-bigoptions') > -1) {


        console.log('selfInstance.$openerWrap- ' ,selfInstance.$openerWrap);
        dzs_slide_down(selfInstance.$openerWrap, {
          duration: 300
          , queue: false
          , complete: function () {

          }
        })
      }

      if (o.opener === 'opener-list') {

      }
    }


    function reinit() {


      // console.info('reinit()');


      // console.info('_t - ',_t);
      // console.info('_t.children() - ',_t.children());

      opener_clearBigOptions(selfInstance);
      // console.log('selfInstance.$feederObject -' ,selfInstance.$feederObject);


      opener_setupBigOptions(selfInstance);
      ;
    }




  }
}

(function ($) {


  $.fn.dzsselector = function (o) {

    //==default options
    var defaults = {
      'opener': ''
      , 'placeholder': 'default'

    };

//        console.info(this, o);

    if (typeof o == 'undefined') {
      if (typeof $(this).attr('data-options') != 'undefined' && $(this).attr('data-options') !== '') {
        var aux = $(this).attr('data-options');
        aux = 'var aux_opts = ' + aux;
        eval(aux);
        o = aux_opts;
      }
    }
    o = $.extend(defaults, o);


    this.each(function () {

      new DzsSelector(this, $, o);

      return this;
    });


  };


  window.dzssel_init = function (selector, settings) {

    // console.info('dzssel_init -  ',selector,settings);
    if (settings && settings.init_each) {
      var element_count = 0;
      for (var e in settings) {
        element_count++;
      }
      if (element_count === 1) {
        settings = {};
      }

      $(selector).each(function () {
        var _t = $(this);
        // console.info('dzssel_init _t ',_t);
        _t.dzsselector(settings)
      });
    } else {
      $(selector).dzsselector(settings);
    }

  };
})(jQuery);

jQuery(document).ready(function ($) {

  // console.info("$('select.dzs-style-me') - ", $('select.dzs-style-me'));

  if (window.dzssel_startup_init) {

    dzssel_init('*.dzs-style-me', {
      init_each: true
      , 'call_from': 'dzssel startup'
    });
  }

  // console.log($('.dzs-style-me-feeder'));
  $('.dzs-style-me-feeder').each(function () {
    var $t = $(this);
    // console.log($t, $t.children());
  })
});


window.svg_star = assets.svg_star;